var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"support",on:{"click":_vm.hideSupport}},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.tipsMsg))]),_vm._v(" "),_c('p',{staticClass:"open_app",on:{"click":_vm.myOpenApp}},[_vm._v("打开南方+，可再打榜+2票")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202fcb47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/support.vue
// module id = null
// module chunks = 